import React, { useEffect, useState, useMemo } from "react";
import {
  Container,
  Typography,
  Box,
  IconButton,
  Tooltip,
  AppBar,
  Toolbar,
} from "@mui/material";
import MaterialReactTable, {
  MRT_FullScreenToggleButton,
} from "material-react-table";
import { MRT_Localization_ES } from "material-react-table/locales/es";
import FactoryIcon from '@mui/icons-material/Factory';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import PersonIcon from '@mui/icons-material/Person';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { useLocation, useNavigate } from "react-router-dom";
import { UrlApiEnvasado } from "../../../services/apirest";
import ArrowBackIcon from '@mui/icons-material/ArrowBack'; // Icono de retroceso


function ListaChoferes() {
    const location = useLocation();
    let navigate = useNavigate();
    const [tabla, setTabla] = useState(true);
    const [choferes, setChoferes] = useState()
  
    const obtenerChoferes = () => {
      fetch(UrlApiEnvasado + "api/envasado/choferes/sucursal/"+location.state.id)
        .then((data) => data.json())
        .then((data) => setChoferes(data));
    };
    useEffect(() => {
        obtenerChoferes()
    }, [])
    
  
      const columns = useMemo(
        () => [
          {
            accessorKey: "id", //access nested data with dot notation
            header: "ID",
            maxSize: 20,
          },
          {
            accessorKey: "name", //access nested data with dot notation
            header: "Nombre",
            size: 115,
          },
          {
            accessorKey: "dni", //access nested data with dot notation
            header: "DNI",
            size: 115,
          },
          {
            accessorKey: "telefono", //access nested data with dot notation
            header: "Telefono",
            size: 115,
          },
        ],
        []
      );
      const customLocalization = {
        ...MRT_Localization_ES,
        expandAll: "Ex", // Cambia 'Expandir todo' a 'Ex'
        expand: "Ex", // Cambia 'Expandir' a 'Ex'
      };
  
      const muiSearchTextFieldProps = {
          placeholder: "Buscar..",
          sx: { minWidth: "18rem", backgroundColor: "#ffffff" },
          variant: "outlined",
          color: "primary",
          size: "small",
        };
        
        const tableHeadCellProps = {
          align: "left",
          sx: {
            fontSize: 16,
            color: "white",
            fontWeight: "normal",
            backgroundColor: "#2471A3",
            borderColor: "black",
          },
        };
      
        const initialState = {
          //para inicializar la tabla, y la cantidad de paginas q se ven ej 5
          density: "compact",
          showGlobalFilter: true,
          pagination: { pageIndex: 0, pageSize: 10 },
        };
  
        const handleGoBack = () => {
            navigate(-1); // Navegar a la página anterior
        };
    return (
      <div>
        {/* <Navbar/> */}
        <AppBar position="static" style={{ backgroundColor: '#2471A3' }}>
                <Toolbar>
                    {/* Botón de retroceso */}
                    <IconButton 
                        edge="start" 
                        color="inherit" 
                        onClick={handleGoBack}
                        style={{ marginRight: '16px' }}
                    >
                        <ArrowBackIcon />
                    </IconButton>
                    {/* Título centrado */}
                    <Typography variant="h6" style={{ flexGrow: 1, textAlign: 'center', fontWeight: '600', letterSpacing: '1px' }}>
                        Choferes de {location.state.name}
                    </Typography>
                    {/* Espacio para equilibrar el botón de retroceso */}
                    <div style={{ width: '48px' }}></div>
                </Toolbar>
            </AppBar>
        <Container maxWidth="xl" disableGutters sx={{ mb: 2, mt: 1 }}>
          {tabla && (
            <Box mt={2} mb={4}>
            <MaterialReactTable
              columns={columns}
              data={choferes ?? [{}]}
              layoutMode={"grid"}
              initialState={initialState}
              enableColumnActions={false} //deshabilita las acciones POR COLUMN}
              enableGlobalFilterModes={false}
              enableHiding={false}
              enableGrouping={true}
              enablePinning={true}
              enableColumnFilters={false}
              enableFullScreenToggle={false}
              positionActionsColumn={"last"}
              enableExpandAll={false}
              enableEditing
              localization={customLocalization}
              enableToolbarInternalActions={true}
              muiTableHeadCellProps={tableHeadCellProps}
              muiSearchTextFieldProps={muiSearchTextFieldProps}
              enableDensityToggle={false}
              // muiTableBodyRowProps={({ row }) => ({
              //   sx: {
              //     backgroundColor: row.original.estado === 272
              //       ? null
              //       : row.original.estado === 273
              //       ? "#ffff88"
              //       : row.original.estado === 274
              //       ? "#acec98"
              //       : null,
              //   },
              // })}
              // muiTableDetailPanelProps={{
              //   sx: {
              //     backgroundColor: 'white', // Fondo blanco para el panel de detalles
              //     width: '100%', 
              //   },
              // }}
              enableColumnResizing={true}
              // renderDetailPanel={({ row }) => <Pedidos_rendicion row={row.original} />}
              muiTableBodyCellProps={({ row }) => ({
                align: "left",
              })}
              renderTopToolbarCustomActions={() => (
                <div style={{alignContent:"center"}}>
                  <Typography variant="poster" fontSize={26}>
                    <PersonIcon sx={{ fontSize: 25 }} />
                      -
                      Choferes
                  </Typography>
                </div>
              )}
              renderRowActions={(
                { row } //las acciones del costado editar y ver
              ) => (
                <div>
                  <Tooltip arrow placement="left" title="Ver Datos">
                    <IconButton
                      onClick={() => navigate("/datoschoferes",{ state: row.original })}
                      color="primary"
                    >
                      <VisibilityIcon />
                    </IconButton>
                  </Tooltip>
                </div>
              )}
            />
            </Box>
          )}
        </Container>
      </div>
    )
}

export default ListaChoferes